import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

const Spinner = ({ className, size = 24, ...props }) => {
  return (
    <Loader2
      className={cn("animate-spin text-primary", className)}
      size={size}
      {...props}
    />
  );
};

export { Spinner };
